const mfa = {
    totp: 'Authenticator app',
    webauthn: 'Passkey',
    backup_code: 'Backup code',
    email_verification_code: 'Email verification code',
    phone_verification_code: 'SMS verification code',
    /** WhatsApp-channel variant of `phone_verification_code`, used when the SMS-type connector delivers over WhatsApp. */
    phone_verification_code_via_whatsapp: 'WhatsApp verification code',
    link_totp_description: 'Such as Google Authenticator',
    link_webauthn_description: 'Link your device or USB hardware',
    link_backup_code_description: 'Generate a backup code',
    link_email_verification_code_description: 'Link your email address',
    link_email_2fa_description: 'Link your email address for 2-step verification',
    link_phone_verification_code_description: 'Link your phone number',
    link_phone_2fa_description: 'Link your phone number for 2-step verification',
    verify_totp_description: 'Enter the code from your authenticator app',
    verify_webauthn_description: 'Verify your device or USB hardware',
    verify_backup_code_description: 'Paste the backup code you saved',
    verify_email_verification_code_description: 'Enter the code sent to your email',
    verify_phone_verification_code_description: 'Enter the code sent to your phone',
    send_to_email: 'Send to {{identifier}}',
    send_to_phone: 'Send to {{identifier}}',
    onboarding: 'Turn on 2-step verification',
    onboarding_description: 'Protect your account with 2-step verification. Choose one or more: passkey, authenticator app, SMS code, or backup codes.',
    enable_mfa: 'Turn on 2-step verification',
    add_mfa_factors: 'Add 2-step verification',
    add_mfa_description: 'Choose a second way to verify it’s you when you sign in.',
    add_another_mfa_factor: 'Add another 2-step verification',
    add_another_mfa_description: 'Add a backup way to verify it’s you when you sign in.',
    verify_mfa_factors: '2-step verification',
    verify_mfa_description: 'Choose how to verify it’s you.',
    add_authenticator_app: 'Add authenticator app',
    replace_authenticator_app: 'Replace authenticator app',
    step: 'Step {{step, number}}: {{content}}',
    scan_qr_code: 'Scan this QR code',
    scan_qr_code_description: 'Scan the following QR code with your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.',
    qr_code_not_available: 'Can’t scan the QR code?',
    copy_and_paste_key: 'Copy and paste the key',
    copy_and_paste_key_description: 'Copy and paste the following key into your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.',
    want_to_scan_qr_code: 'Want to scan QR code?',
    enter_one_time_code: 'Enter the code from your app',
    enter_one_time_code_link_description: 'Enter the 6-digit code from your authenticator app.',
    enter_one_time_code_description: 'Enter the code shown in your authenticator app.',
    enter_email_verification_code: 'Enter email verification code',
    enter_email_verification_code_description: 'Enter the code sent to {{identifier}}.',
    enter_phone_verification_code: 'Enter SMS verification code',
    enter_phone_verification_code_description: 'Enter the code sent to {{identifier}}.',
    /** WhatsApp-channel variants, used when the SMS-type connector delivers over WhatsApp. */
    enter_phone_verification_code_via_whatsapp: 'Enter WhatsApp verification code',
    enter_phone_verification_code_via_whatsapp_description: 'Enter the WhatsApp code sent to {{identifier}}.',
    link_another_mfa_factor: 'Use another method',
    save_backup_code: 'Save your backup code',
    save_backup_code_description: 'Use one of these backup codes if you can’t complete 2-step verification another way. Each code works once.',
    backup_code_hint: 'Copy these codes and store them somewhere safe.',
    new_backup_codes_generated: 'New backup codes have replaced your old codes. Save them in a safe place as soon as possible.',
    enter_a_backup_code: 'Enter a backup code',
    enter_backup_code_description: 'Enter one of the backup codes you saved when you set up 2-step verification.',
    create_a_passkey: 'Create a passkey',
    create_passkey_description: 'Register your passkey using device biometrics, security keys (e.g., YubiKey), or other available methods.',
    try_another_verification_method: 'Use another method',
    verify_via_passkey: 'Verify with passkey',
    verify_via_passkey_description: 'Use your fingerprint, face, screen lock, or a security key.',
    trust_this_device_title: 'Trust this device',
    trust_this_device_description: 'You can skip 2-step verification on this device during future sign-ins.',
    trust_this_device_one: 'Trust this device for {{count}} day',
    trust_this_device_two: 'Trust this device for {{count}} days',
    trust_this_device_few: 'Trust this device for {{count}} days',
    trust_this_device_many: 'Trust this device for {{count}} days',
    trust_this_device_other: 'Trust this device for {{count}} days',
    secret_key_copied: 'Secret key copied.',
    backup_code_copied: 'Backup code copied.',
    mfa_bound: '2-step verification method added.',
    webauthn_not_ready: 'Passkeys are still loading. Wait a moment and try again.',
    webauthn_not_supported: 'WebAuthn is not supported in this browser.',
    webauthn_failed_to_create: 'Unable to create a passkey. Try again or use another method.',
    webauthn_failed_to_verify: 'Unable to verify your passkey. Try again or use another method.',
};
export default Object.freeze(mfa);
